import { IconLayer } from "deck.gl";
import { ICON__MAPPING } from "./iconMapping";

export const renderPointLayer = (props) => {
  const { data, onHover, selected } = props;
  const pointLayer = [new IconLayer({
        id: "points",
        pickable: true,
        data,
        iconAtlas: 'https://s3.us-west-2.amazonaws.com/outway.io/iconAtlas.png',
        iconMapping: ICON__MAPPING,
        getIcon: d => d.icon,
  
        sizeScale: 15,
        getPosition: d => d.coordinates,
        getSize: d => 1.5,
        onHover,
  })]

  return pointLayer;
};

export default renderPointLayer;
